import styled, { css } from "styled-components";

interface GridRowStyleProps {
  $status?: string;
}

export const GridRow = styled.tr`
  height: 50px;

  &:nth-of-type(2n-1) {
    background: ${(props) => props.theme.colors.mainBg};
  }
`;

export const GridData = styled.td`
  padding: 4px 10px;
  font-size: 1.4rem;
  line-height: 140%;
  text-align: center;
  align-items: center;

  div {
    display: flex;
    font-size: 1.2rem;
    text-align: start;
    line-height: 140%;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    span {
      color: ${(props) => props.theme.colors.primary100};
      font-size: 1.1rem;
      font-weight: 600;
    }
  }
`;

export const GridStatusChip = styled.div<GridRowStyleProps>`
  display: flex;
  width: 40px;
  height: 26px;
  color: ${(props) => props.theme.colors.white100};
  font-size: 1.3rem;
  border-radius: 3px;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.$status === "warn" &&
    css`
      background: ${props.theme.colors.yellow100};
    `}

  ${(props) =>
    props.$status === "good" &&
    css`
      background: ${props.theme.colors.green100};
    `}

  ${(props) =>
    props.$status === "danger" &&
    css`
      background: ${props.theme.colors.red100};
    `}
`;
